import React, { useState } from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import AiAssistant from './AiAssistant';

const AiAssistantButton = ({ cvData = null, sector = null }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* Bouton flottant */}
            <button
                onClick={() => setIsOpen(true)}
                className="fixed bottom-6 right-6 z-40 w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700"
                title="Assistant IA CV"
            >
                <ChatBubbleLeftRightIcon className="w-6 h-6" />
            </button>

            {/* Assistant IA */}
            <AiAssistant 
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                cvData={cvData}
                sector={sector}
            />
        </>
    );
};

export default AiAssistantButton;
